import C from "./index271.js";
import { resolveComponent as d, createBlock as i, openBlock as o, Transition as m, withCtx as t, withDirectives as g, createElementVNode as s, withKeys as v, normalizeClass as r, createVNode as p, createElementBlock as u, createCommentVNode as l, withModifiers as h, toDisplayString as c, renderSlot as b, createTextVNode as y, vShow as L } from "vue";
/* empty css         */
import $ from "./index231.js";
const w = ["data-component"], M = { class: "cs-modal__head" }, B = {
  "data-test-id": "header-text",
  class: "cs-modal__title"
}, N = { class: "cs-modal__body" };
function S(e, a, V, D, R, T) {
  const f = d("ms-close"), _ = d("cs-ghost-button"), k = d("cs-primary-button");
  return o(), i(m, {
    "enter-from-class": "opacity-0",
    "enter-to-class": "opacity-100",
    "leave-from-class": "opacity-100",
    "leave-to-class": "opacity-0"
  }, {
    default: t(() => [
      g(s("div", {
        class: r(["cs-modal", {
          "-fullscreen": e.isFullscreen
        }]),
        "data-test-id": "backdrop",
        "data-component": e.$options.name,
        onKeyup: a[1] || (a[1] = v((...n) => e.closeModal && e.closeModal(...n), ["esc"]))
      }, [
        p(m, { name: "dialog" }, {
          default: t(() => [
            e.contentRendered || e.visible ? (o(), u("div", {
              key: 0,
              ref: "dialogRef",
              class: r([[
                {
                  hidden: !e.visible && e.contentRendered
                },
                e.getBackgroundColor()
              ], "cs-modal__dialog"]),
              tabindex: "0",
              role: "dialog",
              "aria-modal": "true",
              "data-test-id": "dialog"
            }, [
              s("div", M, [
                s("button", {
                  class: "cs-modal__close",
                  "aria-label": "Dialog schließen",
                  type: "button",
                  onClick: a[0] || (a[0] = h((...n) => e.closeModal && e.closeModal(...n), ["stop"]))
                }, [
                  p(f)
                ]),
                s("p", B, c(e.headerText), 1)
              ]),
              s("div", N, [
                b(e.$slots, "default", {}, void 0, !0)
              ]),
              e.primaryLabel || e.secondaryLabel || e.$slots.buttons ? (o(), u("div", {
                key: 0,
                class: r(["cs-modal__footer", {
                  "-two": e.primaryLabel && e.secondaryLabel
                }])
              }, [
                b(e.$slots, "buttons", {}, void 0, !0),
                e.secondaryLabel ? (o(), i(_, {
                  key: 0,
                  class: "cs-modal__button",
                  type: "button",
                  isCentered: "",
                  onClick: e.onSecondaryClick
                }, {
                  default: t(() => [
                    y(c(e.secondaryLabel), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])) : l("", !0),
                e.primaryLabel ? (o(), i(k, {
                  key: 1,
                  class: "cs-modal__button",
                  isCentered: "",
                  isLoading: e.isLoading,
                  onClick: e.onPrimaryClick
                }, {
                  default: t(() => [
                    y(c(e.primaryLabel), 1)
                  ]),
                  _: 1
                }, 8, ["isLoading", "onClick"])) : l("", !0)
              ], 2)) : l("", !0)
            ], 2)) : l("", !0)
          ]),
          _: 3
        })
      ], 42, w), [
        [L, e.visible]
      ])
    ]),
    _: 3
  });
}
const I = /* @__PURE__ */ $(C, [["render", S], ["__scopeId", "data-v-c7199f53"]]);
export {
  I as default
};
